import { shouldReindex } from '../../core/parity.js';

const claimed = new Set();

/**
 * Claim a background reindex for this product. Once per page session.
 * @param {string} productId
 * @param {boolean} isAdmin
 * @param {number} docCount
 */
export function claimReindex(productId, isAdmin, docCount) {
  if (!shouldReindex({ claimed, productId, isAdmin, docCount })) return false;
  claimed.add(productId);
  return true;
}
